import React from 'react';
import { IAudiogram } from '../../../models/product-detail';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
interface ISpeechElement {
    audiogram: IAudiogram;
    sides: string[];
    speechType: string;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement>,
        speechType: string,
        side: string
    ) => void;
}

const SpeechElement = ({
    audiogram,
    sides,
    speechType,
    onChange,
}: ISpeechElement) => {
    const intl = useIntl();
    const getValue = (side: string) => {
        if (side.includes('L')) {
            return speechType === 'MCL'
                ? handleZeroValue(audiogram.left.MCL)
                : handleZeroValue(audiogram.left.UCL);
        }
        if (side.includes('R')) {
            return speechType === 'MCL'
                ? handleZeroValue(audiogram.right.MCL)
                : handleZeroValue(audiogram.right.UCL);
        }
        if (side.includes('B')) {
            return speechType === 'MCL'
                ? handleZeroValue(audiogram.MCL)
                : handleZeroValue(audiogram.UCL);
        }
        return undefined;
    };

    //since zero is considered falsy had to use this condition
    const handleZeroValue = (value: number | string | null | undefined) => {
        return value ? value : value === 0 ? 0 : '';
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h4>
                        {intl.formatMessage({
                            id: `Speech_${speechType}`,
                            defaultMessage: `Speech_${speechType}`,
                        })}
                    </h4>
                </div>
            </div>
            <div className="row" id={`Speech_${speechType}`}>
                <div className="col-md-1 col-sm-1 col-xs-1" />
                {sides.map((side) => {
                    return (
                        <div className={`col-xs-2`} key={side}>
                            {side} <br />
                            <input
                                id={`${side}-dB`}
                                className={'form-control'}
                                type="text"
                                maxLength={3}
                                value={getValue(side)}
                                onBlur={(event) =>
                                    onChange(event, speechType, side)
                                }
                                onChange={(event) =>
                                    onChange(event, speechType, side)
                                }
                                style={{
                                    border: `${
                                        side.includes('Right')
                                            ? '1px solid red'
                                            : side.includes('Left')
                                            ? '1px solid blue'
                                            : ''
                                    }`,
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SpeechElement;
